module.exports = __webpack_public_path__ + "img/cjc1_style_6_font_sprite.f5504930.webp";